<div class="group" [ngClass]="{'expanded': expanded}">
    <div class="group-head" (click)="toggleExpanded($event)">
      <div class="title">{{title}}</div>
      <div class="icon">
          <svg
          width="16px"
          height="9px"
          viewBox="0 0 16 9"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              transform="translate(-5.000000, -8.000000)"
              fill="#717D8D"
            >
              <polygon
                points="12.5126344 17 5 9.46315316 5 8 20.0420183 8 20.0420183 9.46315316"
              ></polygon>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="group-body">
      <ng-content></ng-content>
    </div>
  </div>


// WEBPACK FOOTER //
// ./src/app/main/campaign-new/info-group/info-group.component.html